import Documento from './Documento'
import Ato from './Ato'

class AnexoAto {
    constructor(
        {
            id = null, 
            ato_id = null, 
            anexo_ato_documento_id = null,
            ordem_anexo = null, 
            dt_criacao = null, 
            dt_atualizacao = null, 

            arquivo = null,

            documento_anexo_ato = {},
            ato = {},
        } = {}
    ) {
        this.id = id; 
        this.ato_id = ato_id; 
        this.anexo_ato_documento_id = anexo_ato_documento_id;
        this.ordem_anexo = ordem_anexo;
        this.dt_criacao = dt_criacao; 
        this.dt_atualizacao = dt_atualizacao;

        this.arquivo = arquivo;

        this.documento_anexo_ato = documento_anexo_ato ? new Documento(documento_anexo_ato) : new Documento();   
        this.ato = ato ? new Ato(ato) : new Ato();  
    }
}

export default AnexoAto;